import React from 'react';
import { Field } from '@progress/kendo-react-form';
import { FormInput } from '../../fields/FormInput';
import { FormMaskedInput } from '../../fields/FormMaskedInput';
import { FormSearchableInput } from '../../fields/FormSearchableInput';
import { buildFieldValidators } from '../../validators/FormValidator';
import { isFieldOptional, isSearchableFormFillerExtDictionary } from '../fieldMapperHelpers';
import { FieldMapperContext } from '../fieldMapperTypes';

export function renderTextLikeField(ctx: FieldMapperContext): React.ReactElement {
  const {
    ctField,
    fieldLabel,
    choices,
    fieldDisabled,
    handleChange,
    isLoading,
    onSearch,
    onRefresh,
    renderFieldWrapper
  } = ctx;

  if (isSearchableFormFillerExtDictionary(ctField)) {
    return (
      <Field
        key={ctField.name}
        name={ctField.name}
        component={FormSearchableInput}
        label={fieldLabel}
        validator={buildFieldValidators(ctField)}
        optional={isFieldOptional(ctField)}
        hint={ctField.hint}
        min={ctField.min}
        max={ctField.max}
        searchResults={choices}
        isLoading={isLoading}
        onSearch={onSearch}
        disabled={fieldDisabled}
        showSearchIcon={true}
        renderFieldWrapper={renderFieldWrapper}
      />
    );
  }

  return (
    <Field
      key={ctField.name}
      name={ctField.name}
      component={ctField.mask ? FormMaskedInput : FormInput}
      label={fieldLabel}
      validator={buildFieldValidators(ctField)}
      optional={isFieldOptional(ctField)}
      hint={ctField.hint}
      min={ctField.min}
      max={ctField.max}
      mask={ctField.mask}
      onChange={handleChange}
      disabled={fieldDisabled}
      isLoading={isLoading}
      showRefreshButton={ctField.formFiller && ctField.usesExtDictionary}
      onRefresh={onRefresh}
      renderFieldWrapper={renderFieldWrapper}
    />
  );
}
